@if (notification$ | async; as notification) {
  <ng-container>
    <nexweb-accept-form
      [notification]="notification"
      [labels]="labels"
      [heading]="heading"
      [dateTimeFormat]="dateTimeFormat"></nexweb-accept-form>
  </ng-container>
}
